import { useEffect, useMemo, useState } from "react";
import ResultListRenderer from "../C225_LatestBlogPosts/ResultListRenderer";
import { Results } from "../CoveoSearchComponent/CoveoSearchComponent";
import styles from "./C225_LatestBlogPosts.module.scss";

export interface LatestBlogsProps {
  tagFilter: string[];
  categoryFilter?: string[];
  viewMoreLink?: string;
  blogSource: string;
  secondaryTitle: string;
  primaryTitle: string;
}

export const LatestBlogs = (props: {
  content: LatestBlogsProps;
  index: number;
}) => {
  const { content } = props;
  const {
    tagFilter,
    categoryFilter,
    viewMoreLink,
    blogSource,
    secondaryTitle,
    primaryTitle,
  } = content;

  const [totalResults, setTotalResults] = useState<number>();
  const [results, setResults] = useState<Results[]>([]);
  const [isLoading, setIsLoading] = useState(false);

  const requestUrl = useMemo(() => {
    const params = new URLSearchParams();

    params.set("blogSource", blogSource);
    tagFilter?.forEach((tag) => params.append("tagFilter", tag));
    categoryFilter?.forEach((category) =>
      params.append("categoryFilter", category)
    );

    return `/api/coveo/latest-blogs?${params.toString()}`;
  }, [blogSource, tagFilter, categoryFilter]);

  useEffect(() => {
    let cancelled = false;

    const loadLatestBlogs = async () => {
      setIsLoading(true);

      try {
        const response = await fetch(requestUrl);

        if (!response.ok) {
          throw new Error(`Latest blogs request failed: ${response.status}`);
        }

        const data = await response.json();

        if (!cancelled) {
          setResults(data.results ?? []);
          setTotalResults(data.totalResults ?? 0);
        }
      } catch (error) {
        console.error(error);

        if (!cancelled) {
          setResults([]);
          setTotalResults(0);
        }
      } finally {
        if (!cancelled) {
          setIsLoading(false);
        }
      }
    };

    loadLatestBlogs();

    return () => {
      cancelled = true;
    };
  }, [requestUrl]);

  return (
    <div className="wrapper">
      <div className="row">
        <div className="base12">
          <div className={styles["latest-blog-posts"]}>
            {secondaryTitle && <p className={styles.label}>{secondaryTitle}</p>}
            {primaryTitle && <h2>{primaryTitle}</h2>}

            <ResultListRenderer
              totalResults={totalResults}
              viewMoreLink={viewMoreLink}
              results={results}
              isLoading={isLoading}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default LatestBlogs;
